import { isGE } from '../Device'
import { DELAY_TO_TRIGGER_CONTEXTMENU_ON_MOBILE, MIN_INTERVAL_TO_DISTINGUISH_SGLE_FROM_DBL_TAP } from './map.constants'

let lastTimeout
let nbClick = 0
/*
 * On double click, maplibre triggers 2 single `click` events then a `dlbclick` event...
 * Since we’re enabling fullscreen on mobile on a single click, that causes a problem.
 * The fix below handles that situation by calling default handler on single click and zooming on 2 clicks
 */
export const handleMobileTap = (e, mapInstance, handler, { maxZoom }, interact) => {
  nbClick++
  if (!lastTimeout) {
    const currentZoom = mapInstance.getZoom()
    lastTimeout = setTimeout(() => {
      if (nbClick === 1) {
        handler(e)
      } else if (nbClick === 2 && currentZoom < maxZoom) {
        const where = {
          center: e.lngLat,
          zoom: currentZoom + 1,
          curve: 1
        }
        interact(where)
      }
      clearInterval(lastTimeout)
      lastTimeout = undefined
      nbClick = 0
    }, MIN_INTERVAL_TO_DISTINGUISH_SGLE_FROM_DBL_TAP)
  }
}

/*
 * https://github.com/maplibre/maplibre-gl-js/issues/373
 */
export const handleMobileLongTouchAsContextMenu = mapInstance => {
  if (isGE()) return

  let lastTimeout

  mapInstance.on('touchstart', e => {
    if (e.originalEvent?.touches?.length > 1) {
      clearTimeout(lastTimeout)
      return
    }
    lastTimeout = setTimeout(
      () => mapInstance.fire({ ...e, type: 'contextmenu' }),
      DELAY_TO_TRIGGER_CONTEXTMENU_ON_MOBILE
    )
  })
  mapInstance.on('touchmove', () => clearTimeout(lastTimeout))
  mapInstance.on('touchend', () => clearTimeout(lastTimeout))
}
